export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/285acb005d2598eac1815b58d509e92e.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70"></div>
      
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto pt-20">
        <h2 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Играйте с <span className="bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37] bg-clip-text text-transparent">Live</span>-дилерами<br />
          в <span className="bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37] bg-clip-text text-transparent">HD</span> качестве
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto">
          Атмосфера настоящего казино у вас дома. Профессиональные дилеры, трансляции в 4K, 
          сотни столов и щедрые бонусы для новых игроков.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#rating" 
            className="group bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold py-4 px-8 rounded-full hover:shadow-2xl hover:shadow-[#d4af37]/50 transition-all duration-300 flex items-center gap-3 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-live-line text-2xl"></i>
            Начать играть
          </a>
          <button className="group bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-full hover:bg-white hover:text-black transition-all duration-300 flex items-center gap-3 hover:scale-105 whitespace-nowrap">
            <i className="ri-play-circle-line text-2xl"></i>
            Смотреть демо
          </button>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          {[
            { icon: 'ri-live-line', label: '250+ Live игр', value: 'HD/4K' },
            { icon: 'ri-user-star-line', label: 'Русские дилеры', value: '24/7' },
            { icon: 'ri-money-dollar-circle-line', label: 'Быстрые выплаты', value: '15 мин' },
            { icon: 'ri-gift-line', label: 'Бонусы', value: 'до 150000₽' }
          ].map((stat, index) => (
            <div key={index} className="bg-black/40 backdrop-blur-md rounded-2xl p-6 hover:bg-black/60 transition-all duration-300">
              <i className={`${stat.icon} text-4xl text-[#d4af37] mb-3 block`}></i>
              <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-gray-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-[#d4af37]"></i>
      </div>
    </section>
  );
}